import { render } from "./AlertsDetails.vue?vue&type=template&id=19cb6169&scoped=true"
import script from "./AlertsDetails.vue?vue&type=script&lang=js"
export * from "./AlertsDetails.vue?vue&type=script&lang=js"

import "./AlertsDetails.vue?vue&type=style&index=0&id=19cb6169&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19cb6169"]])

export default __exports__